import { Dispatch, FC, SetStateAction } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';

import { CustomerListResponseOutputItemsItem } from '@/api/generated';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface CustomersSearchProps {
  classNames?: string;
  filteredCustomers: Array<CustomerListResponseOutputItemsItem>;
  searchQuery: string;
  setSearchQuery: Dispatch<SetStateAction<string>>;
}

export const CustomersSearch: FC<CustomersSearchProps> = ({
  classNames,
  filteredCustomers,
  searchQuery,
  setSearchQuery,
}: CustomersSearchProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'border-primary flex flex-wrap items-center justify-between gap-4 bg-white px-4 py-4',
        classNames
      )}>
      <div className='flex flex-1 items-center gap-2'>
        <Search />
        <Input
          placeholder={t('customers.searchPlaceholder')}
          type='text'
          value={searchQuery}
          onChange={(event) => {
            setSearchQuery(event.target.value);
          }}
        />
      </div>

      <p className='text-muted-foreground font-mono text-xs'>
        <Trans
          i18nKey='customers.searchResults'
          values={{ count: filteredCustomers.length }}
          components={{
            bold: <span className='text-primary font-semibold' />,
          }}
        />
      </p>
    </div>
  );
};
